// extracted by mini-css-extract-plugin
export default {"error-page-message":"ErrorPage_error-page-message__ynr7A","data-content":"ErrorPage_data-content__LzM68","center":"ErrorPage_center__HiHoS","container":"ErrorPage_container__eEvd+"};